import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router"
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FuseConfigService } from '@fuse/services/config.service';
import {AuthService} from 'app/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { lang_login } from 'app/idiomas/i18n/login/login.lang';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as configuracion from 'app/configuracion/login';
import { DATOS_API } from 'app/auth/auth.datos';
import { ResetPasswordService } from './reset-password.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations   : fuseAnimations
})
export class ResetPasswordComponent  {
  selectedLanguage: any;
  languages: any;
  urlAssets = DATOS_API.urlAssets;
  configLogin:any;
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _translateService: TranslateService,
    private passwordreset:ResetPasswordService,
    private _snackBar: MatSnackBar,
  ) {
    let idiomaNavegador = navigator.language.split("-");
    this.selectedLanguage = idiomaNavegador[0];
    this.configLogin = configuracion.loginCGO;
    this.languages = [
      {
          id   : 'en',
          title: 'English',
          flag : 'us',
          short: 'en'
      },
      {
          id   : 'es',
          title: 'Español',
          flag : 'es',
          short: 'es'
      },
      {
          id   : 'tr',
          title: 'Turkish',
          flag : 'tr',
          short: 'tr'
      },
      {
        id   : 'zh1',
        title: 'Traditional Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'zh2',
        title: 'Simplified Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'pt',
        title: 'Portuguese',
        flag : 'pt',
        short: 'pt'
      }
      /*,{
        id   : 'nl',
        title: 'Dutch',
        flag : 'nl',
        short: 'nl'
      },
      {
        id   : 'de',
        title: 'Deutsche',
        flag : 'de',
        short: 'de'
      }*/
  ];
    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true},
        toolbar  : {hidden: true},
        footer   : {hidden: true},
        sidepanel: {hidden: true},
      }
    };
    //this.selectedLanguage="es";
   }
  ngOnInit() {
  }
  setLanguage(lang): void{
    console.log("Idioma "+lang);
    this.selectedLanguage = lang;
    this._translateService.use(lang);
  }
  userGo:any;
  mensajeCorreo:any=null;
  showMessage:boolean=false;
  typeMensaje:boolean=null;
  disableBtn:boolean=true;
  buscarCorreo(){
    this.disableBtn=true;
    console.log("Buscar "+this.userGo);
    let datos: any = {
      userCGO: this.userGo,
      language: this.selectedLanguage
    };
    this.typeMensaje=null;
    if(this.userGo.length){
      Swal.showLoading();
      this.passwordreset.buscarCorreo(datos).subscribe( (data: any) => {
        this.showMessage=true;
        console.log(data);
        Swal.close();
        if(data.success){
          this.mensajeCorreo='LOGIN.PASSWORD.TRUE';
          this.typeMensaje=true;
          this.disableBtn=true;
        }else{
          this.mensajeCorreo='LOGIN.PASSWORD.ERROR';
          this.typeMensaje=false;
          this.disableBtn=false;
        }
      },error=>{
        this.disableBtn=false;
        console.log("Error");
      });
    }
  }

  validarBtn(){
    this.disableBtn=true;
    let datoCorrecto = true;
    if(this.userGo.length > 4){
      datoCorrecto = this.regexEmail.test(this.userGo);
      if(datoCorrecto){
        this.disableBtn=false;
      }
    }
  }
  openErrorSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
       duration: 15000,
       verticalPosition: 'top',
       panelClass: ['background-red']
    });
  }
  openSuccessSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
       duration: 15000,
       verticalPosition: 'top',
       panelClass: ['background-success']
    });
  }

  openWarningSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
       duration: 15000,
       verticalPosition: 'top',
       panelClass: ['background-warning']
    });
  }

  goPassword(){
    this.router.navigate(['login']);
  }

}
